var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.block},[_c('div',{class:_vm.$style.header},[_c('n8n-heading',{attrs:{"tag":"h3","size":"small","color":"text-base"}},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }